module.exports = __webpack_public_path__ + "img/vertical_7_5_0.4df69ba1.png";